import { InjectionToken, Provider } from '@angular/core';

export enum CommonEnvironmentName {
	TEST = 'TEST',
	PRODUCTION = 'PRODUCTION',
	REPLICA = 'REPLICA',
	STAGING = 'STAGING',
	DEVELOPMENT = 'DEVELOPMENT',
	LOCAL = 'LOCAL',
}

export type ClientId = 'default' | 'ioc';

export interface CommonEnvironment {
	environmentName: CommonEnvironmentName;

	/** Tenant/client identifier selected at build-time. */
	clientId: ClientId;

	/** server is `api.rea.ch` */
	server: {
		url: string;
	};

	/** mainClient is `mobile.rea.ch` */
	mainClient: {
		url: string;
	};

	/** handbook is `handbook.rea.ch` */
	handbook: {
		url: string;
	};

	myGenieServer: {
		url: string;
	};

	microsoft: {
		loginClientId: string;
		loginAuthority: string;
		myGenieClientId: string;
		myGenieAuthority: string;
		teamsIntegrationClientId: string;
		teamsIntegrationAuthority: string;
		teamsAppId?: string;
		widgetSecurityClientId: string;
	};
}

export const COMMON_ENVIRONMENT = new InjectionToken<CommonEnvironment>('COMMON_ENVIRONMENT');

export const provideCommonEnvironment = (env: CommonEnvironment): Provider => {
	return {
		provide: COMMON_ENVIRONMENT,
		useValue: env,
	};
};
